import * as types from './mutation-types'
import backup from '.'

export const fetchBackups = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/super/admin/backups`, { params }).then((response) => {
            commit(types.BOOTSTRAP_BACKUPS, response.data.backups.data)
            commit(types.SET_TOTAL_BACKUPS, response.data.backups.total)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteBackup = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/super/admin/backup/delete`,data).then((response) => {
            commit(types.DELETE_BACKUP, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const downloadBackup = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/super/admin/backup/download`, data, { responseType: 'arraybuffer' }).then((response) => {
            resolve(response)
            let blob = new Blob([response.data], { type: 'application/zip' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = data.file_name
            link.click()
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addBackup = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/api/super/admin/backup/create').then((response) => {
            commit(types.ADD_BACKUP, response.data)
            resolve(response )
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteMultipleBackups = ({ commit, dispatch, state }, file_name) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/super/admin/backup/destory`, { 'file_name': state.selectedBackups }).then((response) => {
            commit(types.DELETE_MULTIPLE_BACKUPS, state.selectedBackups)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const selectBackup = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_BACKUPS, data)
    if (state.selectedBackups.length === state.backups.length) {
        commit(types.SET_SELECT_ALL_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE, false)
    }
}
export const setSelectAllState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE, data)
}

export const selectAllBackups = ({ commit, dispatch, state }) => {
    if (state.selectedBackups.length === state.backups.length) {
        commit(types.SET_SELECTED_BACKUPS, [])
        commit(types.SET_SELECT_ALL_STATE, false)
    } else {
        let allBackupFileNames = state.backups.map(backup => backup.file_name)
        commit(types.SET_SELECTED_BACKUPS, allBackupFileNames)
        commit(types.SET_SELECT_ALL_STATE, true)
    }
}
